









import Vue from "vue";
import { OfficeOnlineParams } from "@/types/OfficeOnlineParams";
import storeHelper from "../store/store-helper";
import Shared from "../shared";

export default Vue.extend({
    name: "officeOnlineFillableForm",
    components: {},
    props: {},
    data: function () {
        return {
            documentVersion: "",
            documentID: ""
        };
    },
    async created() {
        this.documentVersion = this.$route.query.document_version?.toString();
        this.documentID = this.$route.query.document_id?.toString();

        if (!this.documentID || !this.documentVersion || this.documentVersion == "0") {
            console.error("Missing documentId and documentversionId. Could not generate the office online frame");
            this.$router.push({ name: "PageNotFound" });
            return;
        }

        let faviconUrl = await storeHelper.documentStore.getOfficeOnlineFaviconAsync(this.documentID, parseInt(this.documentVersion));
        let tabIconElement = document.getElementById("ctl00_lnkShortcutIcon") as HTMLElement;
        tabIconElement.setAttribute("href", faviconUrl);

        this.startOfficeViewer();
    },
    computed: {},
    methods: {
        async startOfficeViewer() {
            let params = (await storeHelper.documentStore.getOfficeOnlineFilleableFormParamsAsync(
                this.documentID,
                parseInt(this.documentVersion)
            )) as OfficeOnlineParams;

            let viewerElement: HTMLElement = this.$refs.officeonlineviewer as HTMLElement;

            if (viewerElement) {
                Shared.startOfficeOnline(params.AccessToken, params.AccessTokenTtl, params.ActionUrl, viewerElement);
            } else {
                setTimeout(async () => this.startOfficeViewer(), 500);
            }
        }
    }
});
